// extracted by mini-css-extract-plugin
export default {"viewMore":"index_viewMore_M3cot","viewMoreLink":"index_viewMoreLink_qP-Dw"};